import {
  isRequired,
  isValidEmail,
  maxLength,
  isValidImage,
  isValidPhoneNumber,
  isValidUsername,
} from "utils/validators";
import { IMAGE_FORMAT, PLACEHOLDER_IMAGE } from "constant";

export const quickUploadForm = [
  {
    type: "text",
    text: "Name",
    label: "Name",
    id: "name",
    name: "name",
    placeholder: "Enter Name",
    variant: "filled",
    showLabel: true,
    validation: {
      required: isRequired("Name"),
      maxLength: maxLength(50, "Name cannot exceed 50 characters"),
    },
  },
  {
    type: "text",
    text: "Username",
    label: "Username",
    id: "username",
    name: "username",
    placeholder: "Enter Username",
    variant: "filled",
    showLabel: true,
    validation: {
      required: isRequired("Username"),
      maxLength: maxLength(20, "Username cannot exceed 20 characters"),
      validate: isValidUsername(
        "Username must be alphanumeric and can include underscores"
      ),
    },
  },
  {
    type: "text",
    text: "Email Address",
    label: "Email Address",
    id: "emailAddress",
    name: "emailAddress",
    placeholder: "Enter Email Address",
    variant: "filled",
    showLabel: true,
    validation: {
      required: isRequired("Email Address"),
      validate: isValidEmail("Please enter a valid email address"),
    },
  },
  {
    type: "text",
    text: "Phone Number",
    label: "Phone Number",
    id: "phoneNumber",
    name: "phoneNumber",
    placeholder: "Enter Phone Number",
    variant: "filled",
    showLabel: true,
    validation: {
      required: isRequired("Phone number"),
      validate: isValidPhoneNumber("Please enter a valid phone number"),
    },
  },
  {
    type: "imageUpload",
    text: "Horoscope Image Upload",
    label: "Horoscope Image Upload",
    id: "horoscopeImage",
    name: "horoscopeImage",
    placeholder: PLACEHOLDER_IMAGE[200],
    accept: IMAGE_FORMAT,
    validation: {
      required: "Please upload a horoscope image",
      validate: isValidImage("Please upload a valid horoscope image"),
    },
  },
  {
    type: "imageUpload",
    text: "ID Proof Image Upload",
    label: "ID Proof Image Upload",
    id: "idProofImage",
    name: "idProofImage",
    placeholder: PLACEHOLDER_IMAGE[200],
    accept: IMAGE_FORMAT,
    validation: {
      required: "Please upload an ID proof image",
      validate: isValidImage("Please upload a valid ID Proof image"),
    },
  },
  {
    type: "imageUpload",
    text: "Photo 1",
    label: "Photo 1",
    id: "photo1",
    name: "photo1",
    placeholder: PLACEHOLDER_IMAGE[200],
    accept: IMAGE_FORMAT,
    validation: {
      required: "Please upload a photo",
      validate: isValidImage("Please upload a valid image"),
    },
  },
  {
    type: "imageUpload", // need to change it as optional
    text: "Photo 2",
    label: "Photo 2",
    id: "photo2",
    name: "photo2",
    placeholder: PLACEHOLDER_IMAGE[200],
    accept: IMAGE_FORMAT,
    validation: {
      // required: "Please upload a photo",
      validate: isValidImage("Please upload a valid image"),
    },
  },
  {
    type: "imageUpload", // need to change it as optional
    text: "Photo 3",
    label: "Photo 3",
    id: "photo3",
    name: "photo3",
    placeholder: PLACEHOLDER_IMAGE[200],
    accept: IMAGE_FORMAT,
    validation: {
      // required: "Please upload a photo",
      validate: isValidImage("Please upload a valid image"),
    },
  },
  {
    type: "checkbox",
    text: "Terms & Condition",
    label: "Terms & Condition",
    id: "termsAndCondition",
    name: "termsAndCondition",
    preText: "I Agree with",
    linkText: "Terms and Conditions",
    link: "/terms",
    choices: ["I Agree with Terms and Conditions"],
    showLabel: false,
    validation: {
      required: isRequired("You must agree to the terms and conditions"),
    },
  },
  {
    type: "button",
    id: "submit",
    name: "submit",
    text: "Submit",
    label: "Submit",
    showLabel: false,
    handler: "onSubmit",
  },
];
